import { BRAND_ORDER_TERMS_UPDATE } from "constants/action-types";

export const updateOrderTerms = (terms) => ({
    payload: terms,
    type: BRAND_ORDER_TERMS_UPDATE,
});
